import { Navigate, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { motion } from "framer-motion";
import { notifyErrorCustom } from "../../../utils/notify";
import { useEffect } from "react";
import { UserAccountsService } from "../../../services";
import { PreviousPass } from "../../../components/PreviousPass";
import { useTranslation } from "react-i18next";

function StepName({ setName, name, setStep }) {
  const STEPS = {
    STEP_PASS_EMAIL: "stepEmail",
    STEP_PASS_IMAGE: "stepImage",
  };

  const stepsArray = [
    {
      pass: "1º Passo",
      title: "Nome e Sobrenome",
      current: true,
    },
    {
      pass: "2º Passo",
      title: "Email",
      current: false,
    },
    {
      pass: "3º Passo",
      title: "Telefone",
      current: false,
    },
    {
      pass: "4º Passo",
      title: "Senha",
      current: false,
    },
    {
      pass: "5º Passo",
      title: "CPF",
      current: false,
    },
    {
      pass: "6º Passo",
      title: "Endereço",
      current: false,
    },
  ];
  const navigate = useNavigate();

  const handleNavigate = async (type) => {
    if (type === "next") {
      if (name === "") {
        notifyErrorCustom(t("fast_publishing_name_enter_your_fullname_alert"));
        return;
      }
      // setStep(STEPS.STEP_PASS_IMAGE)
      setStep(STEPS.STEP_PASS_EMAIL);
    } else {
      navigate("/signIn");
    }
  };
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ x: "100vw" }}
      animate={{ x: 0 }}
      exit={{ x: "-100vw" }}
      transition={{ type: "tween", duration: 0.5 }}
      style={{
        width: "100%",
        // height: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={styles.box_step}>
        <div>{/* <PreviousPass steps={stepsArray}/> */}</div>
        <div className={styles.box_page}>
          <p style={{ margin: "0px" }}>{t("fast_publishing_register_title")}</p>
          <h1 style={{ marginTop: "0px", fontSize: "45px", fontWeight: 500 }}>
            {t("fast_publishing_create_account")}
          </h1>

          <div className={styles.box_input_name}>
            <p>{t("fast_publishing_name_enter_your_fullname")}</p>
            <input
              className={styles.input_name}
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
              type="text"
              placeholder={t("fast_publishing_name_placeholder_name")}
            />
          </div>
        </div>
        <div className={styles.box_button}>
          <button
            className={styles.back_button}
            onClick={() => handleNavigate("back")}
          >
            {t("back_buttom")}
          </button>
          <button
            className={styles.next_button}
            onClick={() => handleNavigate("next")}
          >
            {t("next_buttom")}
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default StepName;
